import React from 'react';
import { Container, Stack, SxProps, Theme } from '@mui/material';
import { StaticImageData } from 'next/image';

export type ImageBannerProps = React.PropsWithChildren<{
  background?: StaticImageData;
  minHeight?: number | string;
  align?: string;
  justify?: string;
  padding?: number | string;
  sx?: SxProps<Theme>;
}>;

export const ImageBanner: React.FC<ImageBannerProps> = ({
  background,
  minHeight,
  children,
  align,
  justify,
  padding,
  sx,
}) => {
  return (
    <Stack
      sx={{
        width: '100%',
        backgroundImage: background ? 'url(' + background.src + ')' : undefined,
        backgroundSize: 'cover',
        backgroundPosition: 'bottom, center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: align,
        justifyContent: justify,
        minHeight: minHeight,
        padding: padding,
        ...sx,
      }}
    >
      <Container maxWidth={'xl'} sx={{ paddingTop: 8 }}>
        {children}
      </Container>
    </Stack>
  );
};
